import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, Box, Dialog, IconButton, Tooltip, Divider, useMediaQuery, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { getProductassetInfoByProductidandtypeAPI } from "components/productasset/ProductassetAPI";
import { useTheme } from "@mui/material/styles";
import {revokeCustomerApprovalAPI} from "api/OmsOrdermgmtWebServices";
import { updateProductObj } from "store/slice/PharmaSlice";
import { setSnackbarMessage, setSnackbarOpen } from "store/slice/AppSlice";


export default function CustomerApprovedDesign({ approvalDate, setApprovalDate, customerApproved, setCustomerApproved }) {
    const dispatch = useDispatch();
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const [customerApprovedDesign, setCustomerApprovedDesign] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [expanded, setExpanded] = useState(!isMobile);

    useEffect(() => {
        setExpanded(!isMobile);
    }, [isMobile]);

    useEffect(() => {
        getProductassetInfoByProductidandtypeAPI(
            "CUSTOMER",
            productObj.id,
            (response) => setCustomerApprovedDesign(response || []),
            () => {}
        );
    }, [productObj.id]);

    const handleImageClick = (item) => {
        setSelectedImage(item);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedImage(null);
    };

    const handleExpandClick = () => {
        setExpanded((prev) => !prev);
    };

    const handleRevokeCustomerApproval = () => {
        revokeCustomerApprovalAPI(
            { "productid": productObj.id },
            (response) => {
                dispatch(updateProductObj(response.productInfo));
                dispatch(setSnackbarMessage("Customer approval revoked successfully."));
                dispatch(setSnackbarOpen(true));
            },
            () => {}
        );
    };

    return (
        <Box sx={{ width:'100%', pb: 1, backgroundColor: 'white', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',}}>
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        backgroundColor: 'primary.lighter',
                        px: 2,
                        py: 1,
                        borderRadius: 1,
                        display: 'inline-block',
                        width: '100%',
                    }}
                >
                    Customer Approved
                </Typography>
                <IconButton
                    aria-label={expanded ? "Collapse" : "Expand"}
                    onClick={handleExpandClick}
                    size="large"
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                    }}
                >
                    {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>
            {expanded && (
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{
                    borderRadius: 1, mt: 2, mb:2,
                }}>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            height:{lg:'62vh', md:'65vh', sm:'65vh', xs:'20vh'},
                            //maxHeight: 350,
                            overflowY: "auto",
                        }}
                    >
                        {customerApprovedDesign && customerApprovedDesign.length > 0 ? (
                            customerApprovedDesign.map((item, idx) => (
                                <Grid
                                    item
                                    xs={12}
                                    key={idx}
                                    sx={{
                                        mb: 3,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    {item.path && (
                                        <Tooltip title={item.title} arrow>
                                            <Box
                                                component="img"
                                                src={item.path}
                                                alt={item.title}
                                                sx={{
                                                    maxHeight: 200,
                                                    objectFit: "contain",
                                                    borderRadius: 1,
                                                    border: "1px solid #eee",
                                                    background: "#fafafa",
                                                    mb: 1,
                                                    display: 'block',
                                                    mx: 'auto',
                                                    cursor: 'pointer',
                                                    transition: 'border-color 0.2s',
                                                    '&:hover': {
                                                        border: '1px solid #0050b3', // Highlight border on hover
                                                    },
                                                }}
                                                onClick={() => handleImageClick(item)}
                                            />
                                        </Tooltip>
                                    )}
                                    <Box sx={{ width: 220 }}>
                                        <Typography
                                            variant="h6"
                                            align="center"
                                            sx={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                width: '100%',
                                                fontSize: 14
                                            }}
                                        >
                                            {item.title}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body2" color="text.secondary" align="center">
                                    No customer approved images found.
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            )}
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md">
                {selectedImage && (
                    <Box sx={{ p: 1, minWidth: { xs: 300, sm: 500 }, maxWidth: '90vw' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                {selectedImage.title}
                            </Typography>
                            <IconButton onClick={handleCloseDialog} size="large">
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Box>
                            <Divider sx={{mb:2 }} />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <img
                                src={selectedImage.path}
                                alt={selectedImage.title}
                                style={{ 
                                    maxWidth: '100%', 
                                    maxHeight: '100%', 
                                    objectFit: 'contain' }}
                            />
                        </Box>
                    </Box>
                )}
            </Dialog>
            {/* Divider before the button */}
            <Divider sx={{  }} />
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleRevokeCustomerApproval}
                    sx={{
                        minWidth: 220,
                        boxShadow: 3,
                    }}
                >
                    Revoke Customer Approval
                </Button>
            </Box>
        </Box>
    );
}